import * as NUMBER from 'constant/number'
import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { editCategory } from 'action/category'
import { Form, Modal } from 'antd'
import PropTypes from 'prop-types'
import CategoryForm from 'view/page/category-management/component/category-form'
import FormModal from 'view/component/form-modal'
import _ from 'lodash'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'Category edited'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'An Error has occured'
})

const EditCategory = ({ category, editCategory, submitting, sites }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()

  const handleClick = () => {
    setVisible(true)
  }

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const response = await editCategory({ ...values, uuid: category.uuid }, category)
      setVisible(false)
      !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
    }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }
  category.user_type_uuids = !_.isEmpty(category.user_types) ? category.user_types.map((type) => type.uuid) : category.special_group.map((type) => type.uuid)

  return (
    <>
      <a onClick={handleClick}>Edit Category</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          form.setFieldsValue(category)
        }}
        title='Edit Category'
        visible={visible}
      >
        <CategoryForm
          category={category}
          form={form}
          sites={sites}
        />
      </FormModal>
    </>
  )
}

EditCategory.propTypes = {
  category: PropTypes.object,
  editCategory: PropTypes.func,
  sites: PropTypes.array,
  submitting: PropTypes.bool
}

const mapStateToProps = (state) => ({
  sites: state.site.allSites,
  submitting: state.loader.categorySubmitting
})

const mapDispatchToProps = (dispatch) => ({
  editCategory: bindActionCreators(editCategory, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(EditCategory)
